<template>
  <div>
    <div class="title-dialog">
      <p style="font-size: 30px; font-family: Roboto; font-weight: 100;">Login</p>
    </div>
      
    <div class="icon-close">
      <b-icon stacked icon="x" @click="closeDialog()" scale="1.1" class="style-x" v-b-tooltip.hover title="Fechar" ></b-icon>
    </div>

    <div class="wrapper-login-form">
      <b-form>
        <span>E-mail </span><template v-if="errorLogin"><span class="errorLogin"> - {{$t('errorLoginEmail')}}</span></template>
        <b-form-input
        id="input-1"
        v-model="email"
        type="email"
        required
        v-on:keyup.enter="login"
        ></b-form-input>

        <br>

        <span>Senha </span><template v-if="errorLogin"><span class="errorLogin"> - {{$t('errorLoginPwd')}}</span></template>
        <b-form-input
          id="input-2"
          v-model="senha"
          type="password"
          required
          v-on:keyup.enter="login"
        ></b-form-input>
        
        
      </b-form>

    
    <div class="d-flex align-items-end flex-column" >
      <span class="linkForgetPw" @click="forgotPassword()"> {{$t('forgot_password')}} </span>
    </div>
   
    <b-button @click="login()" class="btn_1">
      {{$t('enter')}}
      <b-spinner  v-if="showSpinner" variant="light" small></b-spinner>
    </b-button>
     
    </div>    
  </div>
</template>

<script>
import firebase from '@/firebaseInit.js';
import store from "@/store"
import functionsSharedMixins from '@/shared/functionsSharedMixin';

export default {
    mixins: [functionsSharedMixins],
    data() {
        return {
            email: "",
            senha: "",
            showSpinner: false,
            errorLogin :false,

        };
    },
    methods: {
      login: function() {
        this.showSpinner = true;
        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.senha)
          .then(
            data => {
              if(data){
                this.showSpinner = false;
                store.commit('SET_USER', data)
                this.$emit('showDialogLogin', false )


                //this.$store.commit('setPrivacyPolicyPage', false)
                this.verifyPrivacyPolicyRead(data.user.uid);    
              }
            },
            err => {
              this.showSpinner = false;
              this.errorLogin = true;
            }
          );
      },

      closeDialog: function(){
         this.$emit('showDialogLogin', false )
      },

      forgotPassword(){
        this.$emit('showDialogForgotPassword', true );
      },

    
    }    
}
</script>

<style lang="scss" scoped>
  .wrapper-login-form{
    color: #fff;
    width: 435px;
    padding: 100px 20px 30px 20px;

    form.input{
      border-radius: 20px;
    }
    // ::v-deep.label-login{
    //   margin-bottom: 0;
    // }
    ::v-deep.form-control{
      padding: 0;
      padding-left: 10px;
      font-size: inherit;
      border-radius: 20px;
      background-color: #596fb9;
    color: #fff;
    border: 1px solid #596fb9;
    }

    .linkForgetPw{
      font-size: 12px;
      cursor: pointer;
      text-decoration: underline;
      &:hover{
        text-decoration: underline;
      }
    }

    .errorLogin{
      color:yellow;
    }
          
  }
</style>
